import { loadLazyStylesheet } from 'src/app/_helpers/lazy-stylesheet.helper';

export async function loadCKEditor(): Promise<typeof import('ckeditor5')> {
  const [ck] = await Promise.all([import(/* webpackChunkName: "ckeditor5" */ 'ckeditor5'), loadLazyStylesheet('ckeditor5-styles')]);
  return ck;
}
